<template>
    <div>
        <v-tabs
        	v-model="tab"
            background-color="light-primary"
			active-class="mid-primary"
			color="transparent"
        >
            <v-tab
            	v-for="type in evaluationsTypes"
            	:key="type.evaluationTypeId"
            	:href="`#${type.evaluationTypeId}`"
            	class="white--text"
            >
                {{type.evaluationName}}
            </v-tab>
        </v-tabs>

        <!-- page content -->
        <div class="pa-2">
            <v-form ref="filterForm" @submit.prevent="filter()">
                <v-row dense class="mb-1">
                    <v-col lg="2" md="3" sm="4" cols="6">
                        <v-autocomplete
                            label="اسم الموظف"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="6">
                        <v-text-field
                            label="من تاريخ"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="6">
                        <v-text-field
                            label="إلى تاريخ"
                            outlined
                            dense
                            hide-details
                        />
                    </v-col>
                    <v-spacer/>
                    <v-col cols="auto">
                        <v-btn small color="secondary">
                            {{$T('add')}} {{$T('evaluation')}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>

            <bee-handy-table
            	:headers="[]"
            	:items="[]"
                pagination-on-scroll
            ></bee-handy-table>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    name: 'Evaluations',

    data() {
        return {
            loading: false,
            tab: 0,

            filterData: {
                employeeIds: null,
                sectionId: null,
                jobDescriptionId: null,
                fromDate: moment().startOf('year').format('YYYY-MM-DD`'),
                toDate: moment().endOf('year').format('YYYY-MM-DD'),
            }
        }
    },

    computed: {
        ...mapState({
            evaluationsTypes: state => state.evaluationsTypes.evaluationsTypes
        })
    },

    methods: {
        filter(newScrollOptions) {
            this.loading = true;
            let page = 1;
            let itemsPerPage = 1;
            if (newScrollOptions) {
                page = newScrollOptions.page;
                itemsPerPage = newScrollOptions.itemsPerPage;
            } else if (this.$refs.table) {
                this.$refs.table.resetShownRows();
            }
            this.$store.dispatch('evaluations/fetchAll', {
                employeeIds: this.filterData.employeeIds,
                sectionId: this.filterData.sectionId,
                jobDescriptionId: this.filterData.jobDescriptionId,
                evaluationType: this.tab,
                fromDate: this.filterData.fromDate,
                toDate: this.filterData.toDate,
                page: page,
                perPage: itemsPerPage
            }).finally(() => {
                this.loading = true;
            })
        }
    },

    created() {
        this.loading = true;
        this.$store.dispatch('evaluationsTypes/fetchAll').finally(() => {
            this.loading = false;
        })
    }
}
</script>

<style>

</style>